module.exports = __webpack_public_path__ + "static/media/ux.b093b45b.png";